import { Typography } from '@shared/ui'
import styles from './Language.module.scss'
import { IconArrow } from '@shared/assets'
import { useState } from 'react'
import classNames from 'classnames'
import { useClickOutside } from '@shared/hooks/useClickOutside'
import { useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { options } from '@shared/constants/constants'
export const LanguageSelect = ({ className }) => {
  const [ isOpen, setIsOpen ] = useState(false)
  const dropdownRef = useClickOutside(() => setIsOpen(false))
  const queryClient = useQueryClient()
  const { i18n, t } = useTranslation()

  const handleClick = (language) => {
    localStorage.setItem('i18nextLng', language)
    i18n.changeLanguage(language).then(() => queryClient.invalidateQueries())
    setIsOpen(false)
  }

  return (
    <div className={className} ref={dropdownRef}>
      <button onClick={() => setIsOpen(!isOpen)} className={styles.btn}>
        <Typography variant='bodyTextTwo' color='black'>
          {t('buttons.language')}
        </Typography>
        <div className={classNames(styles.icon, isOpen && styles.iconRotate)}>
          <IconArrow/>
        </div>
      </button>
      <div className={classNames(styles.options, {
        [styles.optionsShow]: isOpen,
        [styles.optionsHide]: !isOpen
      })}>
        {options.map((lang) => 
          <Typography 
            onClick={() => handleClick(lang.value)} 
            className={styles.select}
            variant='bodyTextTwo' 
            color='black' 
            key={lang.value}
          >
            {lang.title}
          </Typography>
        )}
      </div>
    </div>
  )
}
